import React from 'react';
import { Image, Files } from 'lucide-react';
import FileList from './FileList';
import FileActions from './FileActions';

interface FileSectionProps {
  title: string;
  icon: 'image' | 'files';
  files: Array<{ id: string; name: string }>;
  selectedFiles: string[];
  onSelect: (fileName: string, selected: boolean) => void;
  onSelectAll: (selected: boolean) => void;
  onPreview: (fileName: string) => void;
  onDownload: (files: string[]) => void;
  onDelete: (files: string[]) => void;
  canPreview: (fileName: string) => boolean;
}

export default function FileSection({
  title,
  icon,
  files,
  selectedFiles,
  onSelect,
  onSelectAll,
  onPreview,
  onDownload,
  onDelete,
  canPreview
}: FileSectionProps) {
  const selectedInSection = selectedFiles.filter(fileName => 
    files.some(file => file.name === fileName)
  );

  return (
    <div className="bg-white rounded-lg shadow-lg p-6">
      <div className="flex items-center justify-between mb-6">
        <h2 className="text-xl font-semibold text-gray-900 flex items-center gap-2">
          {icon === 'image' ? (
            <Image className="w-6 h-6 text-[#024994]" />
          ) : (
            <Files className="w-6 h-6 text-[#024994]" />
          )}
          {title}
        </h2>
        <span className="text-sm text-gray-500">
          {files.length} documente
        </span>
      </div>

      <FileActions
        selectedFiles={selectedInSection}
        onDownload={onDownload}
        onDelete={onDelete}
      />

      {files.length > 0 ? (
        <FileList
          files={files}
          selectedFiles={selectedFiles}
          onSelect={onSelect}
          onSelectAll={onSelectAll}
          onPreview={onPreview}
          canPreview={canPreview}
        />
      ) : (
        <div className="text-center py-8 text-gray-500">
          Nu există documente
        </div>
      )}
    </div>
  );
}